import { AlertColor, Theme } from '@mui/material';
import {
  CancelOutlined,
  WarningAmberOutlined,
  CheckCircleOutlined,
  InfoOutlined as InfoOutlinedIcon,
} from '@mui/icons-material';
import React from 'react';

export type NotificationSeverity = AlertColor | 'announcement';

export interface ToastStyles {
  text: string;
  border: string;
  background?: string;
  boxShadow?: string;
  backdropFilter?: string;
}

export const SEVERITY_ICONS: Record<NotificationSeverity, React.ReactNode> = {
  error: React.createElement(CancelOutlined, { color: 'error', fontSize: 'small' }),
  warning: React.createElement(WarningAmberOutlined, { color: 'warning', fontSize: 'small' }),
  info: '',
  success: React.createElement(CheckCircleOutlined, { color: 'success', fontSize: 'small' }),
  announcement: React.createElement(InfoOutlinedIcon, { color: 'inherit', fontSize: 'small' }),
};

export const getSeverityStyles = (severity: NotificationSeverity, theme: Theme): ToastStyles => {
  const styles: Record<NotificationSeverity, ToastStyles> = {
    success: {
      text: 'var(--mui-palette-text-primary)',
      border: 'var(--mui-palette-success-main)',
    },
    error: {
      text: 'var(--mui-palette-error-main)',
      border: 'var(--mui-palette-error-main)',
    },
    warning: {
      text: 'var(--mui-palette-text-primary)',
      border: 'var(--mui-palette-warning-main)',
    },
    info: {
      text: 'var(--mui-palette-text-primary)',
      border: 'var(--mui-palette-primary-main)',
    },
    announcement: {
      text: 'var(--mui-palette-text-primary)',
      border: 'var(--mui-palette-elevation-outlined)',
      background: 'rgba(0, 0, 0, 0.00)',
      boxShadow: '0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)',
      backdropFilter: 'blur(12px)',
    },
  };

  return styles[severity] || styles.info;
};
